import tableAppCategoriesBlackLabel from './tableAppCategoriesBlackLabel';

export default {
  title: 'Category Management',
  attributeName: 'appCategory',
  getURL: 'appId/areaId/appCategoryPlay',
  createURL: 'appId/areaId/appCategoryPlay',
  updateURL: 'appId/areaId/appCategoryPlay',
  removeURL: 'appId/areaId/appCategoryPlay',
  sessionParams: ['appId', 'areaId'],
  removeNameField:'name',
  removeText:'You are about to remove the category with name ##name##.',
  tableConfig: tableAppCategoriesBlackLabel,
  autoUpdate: true,
};
